//  Notify events
export const NOTIFY_ME = 'Special Class Notify Me Clicked';
export const UN_NOTIFIED = 'Special Class Notify Me Removed';

//  Educator events
export const EDUCATOR_FOLLOWED = 'Educator Followed';
export const EDUCATOR_UNFOLLOWED = 'Educator Unfollowed';
